import React from "react";
import styles from "./ImageContainer.module.scss";

interface ImageContainerProps {
  src: string;
  alt: string;
}

const ImageContainer: React.FC<ImageContainerProps> = ({ src, alt }) => {
  return (
    <div className={styles.imageWrapper}>
      <img src={src} alt={alt} className={styles.image} />
      <div className={styles.gradOverlayBot}></div>
    </div>
  );
};

export default ImageContainer;
